'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Chip = require('./Chip.js');
var index = require('./Icon/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const IneligibleReasonChip = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement(Chip["default"], {
    as: "span",
    s: {
      background: '#ECECEC',
      border: '1px solid #CCCCCC',
      fontSize: '0.75rem'
    }
  }, children, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    icon: "InfoCircle",
    role: "presentation"
  }));
};

exports["default"] = IneligibleReasonChip;
